
import { RESET_DIALOG_STATE, SET_NEW_STAGE } from "../actions/dialogRoute.action";
import { IDialogHandleState } from "./dialog";

export interface IDialogStages extends IDialogHandleState<any> {
    prevKey: string | null;
    path: string;
}

export interface IDialogRouteStages {
    stages: Record<string, Partial<IDialogStages>>;
};
const initialState: IDialogRouteStages = {
    stages: {}
}
//@ts-ignore
export function DialogRouteReducer(state: Record<string, IDialogStages> = initialState, action: { payload: any, type: string }) {
    switch (action.type) {
        case SET_NEW_STAGE:
            const { key, ...rest } = action.payload;
            const stages = state.stages;
            return {
                ...state,
                stages: { ...stages, [key]: rest }
            }
        case RESET_DIALOG_STATE:
            return {
                stages: {}
            }
        default:
            return state;
    }
}